function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "filter_alt-black-18dp-2",
  "data-name": "filter_alt-black-18dp",
  transform: "translate(-0.096)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M.2,1.509c1.9,2.428,5.42,6.928,5.42,6.928v5.625A.943.943,0,0,0,6.562,15H8.447a.943.943,0,0,0,.943-.937V8.438S12.9,3.938,14.8,1.509A.935.935,0,0,0,14.056,0H.944A.935.935,0,0,0,.2,1.509Z",
  transform: "translate(9.096)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M10,6H6v4H4V6H0V4H4V0H6V4h4Z",
  transform: "translate(0.096 3)"
}));

var SvgIconAddFilter = function SvgIconAddFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter_alt-black-18dp",
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-add-filter.a0b62bf8.svg";
export { ForwardRef as ReactComponent };